import { EventEmitter, Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiModulesService } from '../services/api-modules.service';
import { Router } from '@angular/router';
declare const $: any;
@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private count = 0;
  private spinner$ = new BehaviorSubject<string>('');
  private _sidebarLogo = new BehaviorSubject<string>(null);
  private _loginInfo = new BehaviorSubject<any>(null);

  // Renderer2 is not injectable directly in a service — we use RendererFactory2
  private renderer: Renderer2;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private apiModulesService: ApiModulesService,
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private doc: Document,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  /* ── Spinner ── */
  getSpinnerObserver(): Observable<string> { return this.spinner$.asObservable(); }

  requestStarted() { if (++this.count === 1) { this.spinner$.next('start'); } }

  requestEnded() { if (this.count === 0 || --this.count === 0) { this.spinner$.next('stop'); } }

  resetSpinner() { this.count = 0; this.spinner$.next('stop'); }

  dataemitterr = new EventEmitter<any>();
  raiseDataEmitterEvent(data: any) { this.dataemitterr.next(data); }

  /* ── Sidebar / Login info ── */
  get sidebarLogo(): Observable<string> { return this._sidebarLogo.asObservable(); }
  get loginInfo(): Observable<any> { return this._loginInfo.asObservable(); }
  setSidebarLogo(imageUrl: string) { this._sidebarLogo.next(imageUrl); }
  setLoginInfo(loginInfo: any) { this._loginInfo.next(loginInfo); }

  applyUserAppearance(): void {
    try {
      const userRaw = localStorage.getItem('user') || localStorage.getItem('userDetails');
      const user = userRaw ? JSON.parse(userRaw) : null;
      if (!user) {
        this.renderer.removeAttribute(this.doc.documentElement, 'data-color');
        this.renderer.removeAttribute(this.doc.documentElement, 'data-theme');
        return;
      };
      if (user.dark_mode == '1') {
        this.renderer.setAttribute(this.doc.documentElement, 'data-theme', 'dark');
      } else {
        this.renderer.removeAttribute(this.doc.documentElement, 'data-theme');
      }

      const color = user.messenger_color ?? '';
      if (color && color !== 'indigo') {
        this.renderer.setAttribute(this.doc.documentElement, 'data-color', color);
      } else {
        this.renderer.removeAttribute(this.doc.documentElement, 'data-color');
      }

      localStorage.setItem('app_color', color || 'indigo');
      this.setSidebarLogo(user.image ? 'data:image/png;base64,' + user.image : null);
    } catch {
    }
  }

  /* ── Error handler ── */
  toasterError(err: any) {
    this.raiseDataEmitterEvent('off');
    if (err?.status == 401) {
      let params: any = {};
      params.token = localStorage.getItem('token');
      this.apiModulesService.list('logout', params).subscribe();
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('is_first_login');
      window.localStorage.clear();
      ($('#logout_pop_up') as any).modal('hide');
      this.router.navigateByUrl('/login');
      return;
    }
    let errorMessage = 'Something went wrong';
    if (typeof err === 'string') {
      errorMessage = err;
    } else if (err?.code && err?.message) {
      errorMessage = err.message;
    } else if (err?.error?.data) {
      let errorsData = err.error.data;
      let firstKey = Object.keys(errorsData)[0];
      let errors = errorsData[firstKey];
      if (typeof errors === 'string') {
        errors = errors.replace('SQLSTATE[42000]: [Microsoft][ODBC Driver 17 for SQL Server][SQL Server]', 'Error: ');
        errors = errors.replace('SQLSTATE[42000]: [Microsoft][ODBC Driver 18 for SQL Server][SQL Server]', 'Error: ');
      }
      errorMessage = errors;
    } else if (err?.error?.message) {
      errorMessage = err.error.message;
    } else if (err?.message) {
      errorMessage = err.message;
    }
    this.toastr.error(errorMessage, 'TryAgain');
  }

  /* ── Misc helpers ── */
  leaveapplyemitterr = new EventEmitter<any>();
  compOffEmitterEvent(data: any) { this.leaveapplyemitterr.next(data); }

  getSeverity(status: string) {
    switch (status.toLowerCase()) {
      case 'inactive': return 'danger';
      case 'active': return 'success';
    }
  }

  getAcronym(str: any) {
    var matches = str.match(/\b(\w)/g);
    matches = matches.slice(0, 2);
    return matches.join('');
  }

  getBgColors(str: any) {
    var index = this.findAlphapositions(str, 1);
    return ''
  }

  findAlphapositions(str: any, n: any) {
    var NUM = 31;
    return str[0].charCodeAt(0) & NUM;
  }
}
